export * from './action';
export * from './activeContractData';
export * from './address';
export * from './affinity';
export * from './amountDetail';
export * from './aniaBersaniAlienato';
export * from './aniaSaleabilityError';
export * from './aniaValidation';
export * from './attachment';
export * from './autoDetail';
export * from './bankAccountInfo';
export * from './bollettinoInfo';
export * from './caiCircustance';
export * from './canDownloadATR';
export * from './canDownloadATRResponse';
export * from './cancellation';
export * from './carClaim';
export * from './carClaimCircumstances';
export * from './carClaimDamages';
export * from './carClaimDescription';
export * from './carClaimInfo';
export * from './carClaimProfessional';
export * from './chatVisibility';
export * from './checkFalseNewBusinessRequest';
export * from './checkSaleability';
export * from './claim';
export * from './claimAutoRisk';
export * from './claimDamagesInfo';
export * from './claimExternalDamagesInfo';
export * from './claimHomeRisk';
export * from './claimInjuredPeople';
export * from './claimProceedingStatus';
export * from './claimRequestOtherParticipants';
export * from './claimRequestPoliceForce';
export * from './claimRequestWitness';
export * from './client';
export * from './clientComplete';
export * from './clientPolicyParticipants';
export * from './clientPolicyVehicles';
export * from './commercialProduct';
export * from './company';
export * from './completeAnnualAmn';
export * from './consentsContent';
export * from './consentsDataElement';
export * from './consentsPageable';
export * from './consentsPurpose';
export * from './consentsSort';
export * from './contactMethod';
export * from './contactUsRequest';
export * from './contactUsResponse';
export * from './coupon';
export * from './coverage';
export * from './createEasyQuoteRequest';
export * from './createEasyQuoteResponse';
export * from './createOrderRequest';
export * from './createdUser';
export * from './credentialResponse';
export * from './credentialUser';
export * from './creditCardByPhoneInfo';
export * from './creditCardInfo';
export * from './crifValidation';
export * from './currencyIsoCode';
export * from './customerData';
export * from './damageAreas';
export * from './damageType';
export * from './dataProtection';
export * from './deductibleDetail';
export * from './deductibleValue';
export * from './discountedAmn';
export * from './document';
export * from './documentData';
export * from './documentMetadata';
export * from './documentOwner';
export * from './downloadResponse';
export * from './driver';
export * from './errorComponent';
export * from './errorInfo';
export * from './executePaymentRequest';
export * from './executePaymentResponse';
export * from './feeAmn';
export * from './financialEntityBranch';
export * from './findAggregatorsClient';
export * from './findClientError';
export * from './findClientNotFoundError';
export * from './findomesticInfo';
export * from './findomesticRequest';
export * from './findomesticResponse';
export * from './gdprConsent';
export * from './generalCaiQuestions';
export * from './getInformationRequest';
export * from './getInformationResponse';
export * from './homeClaim';
export * from './homeClaimDamages';
export * from './homeClaimInfo';
export * from './homeClaimMaterialDamages';
export * from './homeClaimOrigin';
export * from './homeClaimOtherParticipants';
export * from './homeClaimParticipantsAuthorities';
export * from './homeClaimThirdPartiesDamages';
export * from './homeClaimType';
export * from './homeDetail';
export * from './homePolicy';
export * from './homeProject';
export * from './homeRisk';
export * from './homeSimulation';
export * from './identificationMethod';
export * from './informativeMessage';
export * from './installmentValidation';
export * from './integrationTokenJwtResponse';
export * from './integrationTokenJwtResponsePolicy';
export * from './integrationTokenPayloadInfo';
export * from './intermediary';
export * from './invoice';
export * from './ivassHistory';
export * from './limitValue';
export * from './limitsDetail';
export * from './link';
export * from './loginResponse';
export * from './mathematicalResult';
export * from './mimeType';
export * from './mixedSelectParameterResult';
export * from './modelError';
export * from './mortgage';
export * from './motorPolicy';
export * from './motorProject';
export * from './motorRisk';
export * from './motorSimulation';
export * from './naturalPerson';
export * from './nexiPaymentRequest';
export * from './objectDamageDetail';
export * from './oneTrustConsentsResponse';
export * from './optional';
export * from './orderDetail';
export * from './parameterResult';
export * from './participant';
export * from './partnershipCard';
export * from './partnershipType';
export * from './partnershipValidation';
export * from './paymentMethod';
export * from './paymentModality';
export * from './paymentResponseError';
export * from './paypalInfo';
export * from './paypalOrderResponse';
export * from './paypalPaymentRequest';
export * from './person';
export * from './personName';
export * from './personalDamaged';
export * from './personalInjured';
export * from './plan';
export * from './planAmounts';
export * from './policiesQuotesRequest';
export * from './policyClient';
export * from './policyDataModificationResponse';
export * from './policyDocument';
export * from './policyRole';
export * from './policyVehicle';
export * from './premiumDetail';
export * from './premiumDiff';
export * from './premiumDiscount';
export * from './premiumDiscountAmn';
export * from './premiumPaymentModality';
export * from './prestazione';
export * from './proceeding';
export * from './proceedingTask';
export * from './professional';
export * from './professionalType';
export * from './program';
export * from './quickValidationMap';
export * from './quotePolicy';
export * from './quotePolicyResponse';
export * from './relatedProjectPolicy';
export * from './reportClaimType';
export * from './rfsDiscount';
export * from './rfsOption';
export * from './risk';
export * from './savedAmn';
export * from './sectorCode';
export * from './secureLink';
export * from './securityInfo';
export * from './simulationCommercialProduct';
export * from './solveAffinity';
export * from './solveAffinityRequest';
export * from './stackTrace';
export * from './step';
export * from './successfulResponse';
export * from './sumInsuredAmn';
export * from './sumInsuredDetail';
export * from './technicalData';
export * from './theftDetail';
export * from './timestamp';
export * from './totalAmn';
export * from './updateConsentsRequest';
export * from './user';
export * from './userGdpdResponse';
export * from './userIdentification';
export * from './userPassLogin';
export * from './userRequest';
export * from './usersId';
export * from './validateCuClasses';
export * from './validateFiscalCode';
export * from './validatePartnershipCard';
export * from './validatePlateNumber';
export * from './validatePolicy';
export * from './validateVehiclePurchaseYear';
export * from './validateZipCode';
export * from './validateZipCodeResponse';
export * from './validationCheckfalseNewBussiness';
export * from './validationCouponResponse';
export * from './validationError';
export * from './validationResponse';
export * from './vehicleDetail';
export * from './vehicleFoundDetail';
export * from './vehicleOptional';
export * from './vehicleStolenDetail';
export * from './vehicleType';
export * from './vertiLogin';
export * from './vertiLoginError';
export * from './witnessDetail';
